<div class="ap-message-editor emds" id="{{Id}}">
  <form #createMessageForm="ngForm" (ngSubmit)="send()" novalidate>
    <div class="flex-div" *ngIf="!readOnly">
      <ngx-toasta></ngx-toasta>
      <!-- Enter A Message -->
      <div class="flex-row">
        <div class="flex-item form-group">
          <label class="active" translate="">Type Your Reply</label>
          <ap-html-text-editor
              [(ngModel)]="messageBody"
              name="messageBody"
              [height]="120"
              [hideToolbar]="true"
              [hideStatusBar]="true"
              [editorName]="'enterAMessageReply'"
              [required]="false"
              [displayName]="'Type Your Reply'"
              (textContentChanged)="onTextContentChanged($event)"
              #apHtmlTextEditor>
          </ap-html-text-editor>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-row flex-item">
          <!-- Due Date -->
          <div class="form-group">
            <ap-date-picker
              [baseId]="Id + '-duedate'"
              [required]="false"
              name="duedate"
              [labelName]="'Due Date'"
              [(ngModel)]="dueDate"
              [disabled]="readOnly"
              (ngModelChange)="updateDueDate($event)">
            </ap-date-picker>
          </div>
          <!-- Urgency-->
          <div class="form-group">
          <label class="active" translate="">Urgency</label>
          <ap-findcontrol [baseId]="Id + '-urgency'"
                          [findControlId]="findControlIdService.ListMessageUrgency"
                          [(selectedPk)]="urgencyId"
                          (selectedPkChange)="onMessageUrgencyChange($event)"
                          [placeHolder]=""
                          [singleSelect]="true"
                          [form]="createMessageForm"
                          [disabled]="readOnly">
          </ap-findcontrol>
          </div>
        </div>
        <div class="flex-row">
          <div class="flex-item ap-message-edtior-button-group">
            <div>
              <button type="button"
                      class="btn btn-secondary pull-right"
                      *ngIf="!showButtons ? true : showButtons.Complete"
                      [disabled]="readOnly || completingMessage || readOnly || messageLength > 0"
                      (click)="complete()"
                      translate>
                <span translate [hidden]="completingMessage">Complete</span>
                <ap-spinner *ngIf="completingMessage" size="1"></ap-spinner>
              </button>

              <button type="submit"
                      class="btn-primary btn pull-right"
                      *ngIf="!showButtons ? true : showButtons.Send"
                      [disabled]="readOnly || completingMessage || sendingMessage || messageLength === 0"
                      translate>
                <span translate [hidden]="sendingMessage">Send</span>
                <ap-spinner *ngIf="sendingMessage" size="1"></ap-spinner>
              </button>

              <button type="button" class="btn btn-secondary pull-right"
                      *ngIf="!showButtons ? true : showButtons.Cancel"
                      [disabled]="completingMessage || sendingMessage"
                      (click)="cancel()"
                      translate>
                      Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
